import { render, staticRenderFns } from "./AlertSuccess.vue?vue&type=template&id=28ab76a6&scoped=true"
import script from "./AlertSuccess.vue?vue&type=script&lang=js"
export * from "./AlertSuccess.vue?vue&type=script&lang=js"
import style0 from "./AlertSuccess.vue?vue&type=style&index=0&id=28ab76a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ab76a6",
  null
  
)

export default component.exports